export default "__VITE_ASSET__d5920578__"